module.exports = __webpack_public_path__ + "img/search.60198b1c.svg";